import { createI18n } from "vue-i18n";
import th from "./locales/th.json";
import en from "./locales/en.json";

const stored = localStorage.getItem("telemed_lang");
export const i18n = createI18n({
  legacy: false,
  globalInjection: true,
  locale: stored === "en" || stored === "th" ? stored : "th",
  fallbackLocale: "th",
  messages: { th, en },
});

export function setLocale(lang: "th" | "en") {
  i18n.global.locale.value = lang;
  localStorage.setItem("telemed_lang", lang);
}
